module.exports = __webpack_public_path__ + "img/team-listens-mob.47feb304.webp";